import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import withSizes from "react-sizes";
import { Header, Button } from '../../components';
import style from './Notfound.module.scss';
import queryString from 'query-string';
import { useSelector } from 'react-redux'
import useLocale from '../../hooks/useLocale';

function HookWrapper({
  render
}) {
  return render( loadGlossary(), useLocale());
}

function loadGlossary() {
  const { data } = useSelector(state => state.global)
  return (data && data.glossary) || {}
}




class Notfound extends Component {

   constructor(props) {
    super(props);
  
  }

  
  render() {
    const { isMobile } = this.props;

    return (
      <HookWrapper render={(glossary, locale) => {
        let title = "Page Not Found"
        let caption = "Sorry, there is nothing here."
        let keyword = "The page you are looking for cannot be found"
        let buttonText = "GO TO HOME"
        if(locale === 'id'){
          title = "Halaman Tidak Ditemukan"
          caption = "Maaf, tidak ada informasi disini."
          keyword = "Halaman yang anda cari tidak dapat ditemukan"
          buttonText = "KEMBALI KE BERANDA"
        }

        return (
          <>
            <MetaTags>
              <title>{title} | Aura Design</title>
              <meta name="description" content=""/>
              <meta name="keyword" content="" />
              <meta property="og:title" content="Page Not Found" />
            </MetaTags>
            <Header />

            <div className="page__container">
              <div className={style.container}>
                <div className={style.caption}>{caption}</div>
                <h3 className={style.keyword}>{keyword}</h3>
                <div className={style.button__panel}>
                  <Button type="redirect" link={`/${locale}`} full={isMobile} buttonName={buttonText} />
                </div>
              </div>
            </div>
          </>
        )
      }} />
    );
  }
}

const mapStateToProps = ({ width }) => ({
  isMobile: width <= 500
});

export default withSizes(mapStateToProps)(Notfound);